import { Icon, type IconName } from "../Icon";
import { PulsingIcon } from "../PulsingIcon";
import { ShimmerSpan } from "../ShimmerSpan";
import { Text } from "../Text";
import { TypewriterSpan } from "../TypewriterSpan";

type Props = {
  icon: IconName;
  text: string;
  pending?: boolean;
  iconColor?: string;
};

export function ToolStatus({
  icon,
  text,
  pending = false,
  iconColor = "var(--text-secondary)",
}: Props) {
  return (
    <>
      <PulsingIcon data-pending={pending}>
        <Icon name={icon} size={12} color={iconColor} />
      </PulsingIcon>
      <Text variant="text-small" color="var(--text-secondary)" ellipsis>
        <ShimmerSpan data-pending={pending}>
          <TypewriterSpan>{text}</TypewriterSpan>
        </ShimmerSpan>
      </Text>
    </>
  );
}
